// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"af3d9044","796":"2d33bc69"}[chunkId] + ".chunk.js";
};